import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    delay: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
    console.log("Autosearch controller connected", this.urlValue)
  }

  search() {
    clearTimeout(this.timeout)
    
    this.timeout = setTimeout(() => {
      this.performSearch()
    }, this.delayValue)
  }

  performSearch() {
    const url = new URL(this.urlValue, window.location.origin)
    
    // Collect all form inputs
    this.element.querySelectorAll('input, select').forEach(input => {
      if (input.name && input.value) {
        url.searchParams.set(input.name, input.value)
      }
    })

    // Update browser URL without reload
    window.history.replaceState({}, '', url.toString())

    // Use XMLHttpRequest to avoid fetch conflicts
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url.toString(), true)
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    xhr.setRequestHeader('Accept', 'text/html')
    
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const currentTable = document.getElementById('users-table-content')
        if (currentTable) {
          // Create a temporary div to parse the response
          const temp = document.createElement('div')
          temp.innerHTML = xhr.responseText
          const newContent = temp.querySelector('#users-table-content')
          if (newContent) {
            currentTable.innerHTML = newContent.innerHTML
          } else {
            // If the partial doesn't have the wrapper, use the whole response
            currentTable.innerHTML = xhr.responseText
          }
        }
      }
    }
    
    xhr.onerror = () => {
      console.error('Search request failed')
    }
    
    xhr.send()
  }

  // Clear search and reset
  clear(event) {
    event.preventDefault()
    
    this.element.querySelectorAll('input[type="text"], input[type="search"]').forEach(input => {
      input.value = ''
    })
    this.element.querySelectorAll('select').forEach(select => {
      select.selectedIndex = 0
    })
    
    this.performSearch()
  }
}
